interface Props {
  title: string;
}

export default ({ title }: Props) => {
  const documentTitle = `${title}${title ? ' - ' : ''}CrowdWorks`;
  document.title = documentTitle;
  return null;
};
